module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"brochure_img":"/Resources/Images/produits/BrochureFR_C400L.jpg","pdf":"/Resources/Documents/C400L-CMI_BrochureFR2020-06182025_Tabloid-web.pdf"},"en":{"brochure_img":"/Resources/Images/produits/BrochureEN_C400L.jpg","pdf":"/Resources/Documents/C400L-CMI_BrochureENG2020-06182025_Tabloid-web.pdf"}}')
  delete Component.options._Ctor
}
